import React, { useState } from 'react';
import styled from 'styled-components';

const SelectWrap = styled.div`
        & > select{
            display:none;
        }
    `;
const CustomSelectBox = styled.ul`
        width: 100%;
        padding: 8px 0;
        margin:0;
        border-radius: 5px;
        border: solid 1px #dbdbdb;
        background-color: #fff;
        position:absolute;
        left:-1px;
        right:0;
        top:100%;
        list-style: none;
        z-index:2;
        display:${props => props.visible ? "block" : "none"};
        & > li{
            padding:5px 17px;
            &:hover{
                background-color: #efefef;
            }
        }
    `;
const CustomSelectBtn = styled.div`
        position: relative;
        width: 100%;
        height: 45px;
        margin: 14.9px 0 20.8px 0;
        padding: 12px 15.7px 12px 17.2px;
        box-sizing:border-box;
        border-radius: 5px;
        border: solid 1px #dbdbdb;
        background-color: #fff;
        font-family: 'Noto Sans KR', sans-serif;
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.33;
        letter-spacing: normal;
        text-align: left;
        color: #494949;
        cursor: pointer;
        & > svg{
            transform:${props => props.opened ? "rotate(-180deg)" : "none"};
            float:right;
        }
    `;
function Select({ options, placeholder, selectCallback = () => { }, value = "" }) {
    const [selectedBoxVisible, setSelectedBoxVisible] = useState(false);
    return (
        <SelectWrap>
            <CustomSelectBtn opened={selectedBoxVisible} onClick={(e) => {
                setSelectedBoxVisible(!selectedBoxVisible);
            }}>
                <span>{value || placeholder}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                </svg>
                <CustomSelectBox visible={selectedBoxVisible}>
                    {[...options].map((x, i) => <li key={i} onClick={(e) => {
                        selectCallback(e, x, i);
                    }}>{x.value || x}</li>)}
                </CustomSelectBox>
            </CustomSelectBtn>
        </SelectWrap>
    );
}

export default Select;